import React from "react";
import { bool, number, string } from "prop-types";

import * as S from "./styled";

const AgentStats = ({
  className,
  medianSalesPrice,
  nearbyHomes,
  recentHomesSold,
  similarHomes,
  soldHomesInUserBuilding,
  yearsExperience
}) => (
  <S.Container className={className} data-qa="agent-sale-stats">
    {soldHomesInUserBuilding && (
      <S.AgentBanner>Sold homes in this building</S.AgentBanner>
    )}
    <S.SimilarHomes nearbyHomes={nearbyHomes} similarHomes={similarHomes} />
    <S.AgentExperience
      medianSalesPrice={medianSalesPrice}
      recentHomesSold={recentHomesSold}
      yearsExperience={yearsExperience}
    />
  </S.Container>
);

AgentStats.propTypes = {
  className: string,
  nearbyHomes: number,
  medianSalesPrice: string,
  similarHomes: number,
  soldHomesInUserBuilding: bool,
  recentHomesSold: number,
  yearsExperience: number
};

AgentStats.defaultProps = {
  className: "",
  nearbyHomes: null,
  medianSalesPrice: "",
  similarHomes: null,
  recentHomesSold: null,
  soldHomesInUserBuilding: false,
  yearsExperience: null
};

export default AgentStats;
